import { FC, PropsWithChildren } from 'react';

import { withStaticProperties } from '../../lib/withStaticProperties';

import {
  StyledXLarge,
  StyledH1,
  StyledH2,
  StyledH3,
  StyledH4,
  StyledH5,
  StyledH6,
  StyledParagraph,
  StyledSpan,
  StyledSmall,
  StyledMedium,
  StyledSpanSmall,
} from './Typography.ui';

const TypographyGeneral: FC<PropsWithChildren> = (props) => {
  const { children } = props;

  return children;
};

const Typography = withStaticProperties(TypographyGeneral, {
  H1: StyledH1,
  H2: StyledH2,
  H3: StyledH3,
  H4: StyledH4,
  H5: StyledH5,
  H6: StyledH6,
  Text: StyledSpan,
  Paragraph: StyledParagraph,
  Small: StyledSmall,
  Medium: StyledMedium,
  XLarge: StyledXLarge,
  TextSmall: StyledSpanSmall,
});

Typography.displayName = 'Typography';

export { Typography };
